import { render, staticRenderFns } from "./DetallesRecepcion.vue?vue&type=template&id=011f6403&scoped=true"
import script from "./DetallesRecepcion.vue?vue&type=script&lang=js"
export * from "./DetallesRecepcion.vue?vue&type=script&lang=js"
import style0 from "./DetallesRecepcion.vue?vue&type=style&index=0&id=011f6403&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011f6403",
  null
  
)

export default component.exports